import React,{useState, useEffect} from "react";
import { Trans, useTranslation} from 'react-i18next'
import purpledownloadicon from './../../../images/purpledownloadicon.png'
import filtersicon from './../../../images/filtersicon.png'
import royaltiesfluctuateicon from './../../../images/royaltiesfluctuateicon.png'
import royaltiesdownicon from './../../../images/royaltiesdownicon.png'
import SearchIcon from "./../../../images/searchicon.png"
import WhiteSearchIcon from "./../../../images/whitesearchicon.png"
import './Products.css'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import Select from 'react-select'


function Artists({nav}) {
    const {t, i18n } = useTranslation();
    const cookies = new Cookies(null ,{ path: '/' });
    const [groupBy,setGroupBy] = useState("")
    const [search,setSearch] = useState();
    const [artistFilter,setArtistFilter] = useState({value:'Artists', label:'Artists'});
    const [labelFilter,setLabelFilter] = useState({value:'Labels', label:'Labels'});
    const [statusFilter,setStatusFilter] = useState({value:'Status', label:'Status'});
    const [tagFilter,setTagFilter] = useState({value:'Tags', label:'Tags'});
    const [dspFilter,setDSPFilter] = useState({value:'DSP', label:'DSP'});
    const [sortByFilter,setSortByFilter] = useState({value:'Sort by: Date Added', label:'Sort by: Date Added'});

    const dummydata = [{DSP:"Spotify",Streams:"43,460,905",Downloads:"0",Revenue:"$90,318.67"},
    {DSP:"Apple Music",Streams:"3,346,008",Downloads:"0",Revenue:"$90,318.67"},
    {DSP:"Amazon Unlimited",Streams:"1,456,769",Downloads:"0",Revenue:"$11,389.12"},
    {DSP:"Youtube Ad Supported",Streams:"18,419,281",Downloads:"0",Revenue:"$6,849.61"},
    {DSP:"Youtube Music",Streams:"18,419,281",Downloads:"0",Revenue:"$6,789.76"},
    {DSP:"Netease Cloud Music",Streams:"5,210,954",Downloads:"0",Revenue:"$2,449.37"},
    {DSP:"iTunes",Streams:"349",Downloads:"2,670",Revenue:"$1,937.30"},
    {DSP:"Tencent",Streams:"2,782,852",Downloads:"227",Revenue:"$1,589.95"},
    {DSP:"Deezer",Streams:"278,390",Downloads:"0",Revenue:"$1,235.34"},
    {DSP:"Kakao / MelOn",Streams:"406,467",Downloads:"0",Revenue:"$965.38"},
    {DSP:"Amazon Prime",Streams:"442,853",Downloads:"0",Revenue:"$654.51"}]

    const groupByOptions = [{value:'DSP', label:'DSP'},
    {value:'Title', label:'Title'},
    {value:'Artist', label:'Artist'},
    {value:'Label', label:'Label'},
    {value:'Sale Type', label:'Sale Type'},
    {value:'Statement Period', label:'Statement Period'},
    {value:'Territory', label:'Territory'},
    {value:'Barcode', label:'Barcode'},
    {value:'ISRC', label:'ISRC'}]

    const artistOptions = [{value:'Artists', label:'Artists'}]
    const labelOptions = [{value:'Labels', label:'Labels'}]
    const statusOptions = [{value:'Deleted', label:'Deleted'},{value:'Draft', label:'Draft'},{value:'Approved', label:'Approved'},{value:'To be accepted', label:'To be accepted'}]
    const tagsOptions = [{value:'Tags', label:'Tags'}]
    const dspOptions = [{value:'DSP', label:'DSP'}]
    const sortByOptions = [{value:'Sort by: Date Added', label:'Date added'},{value:'Sort by: Release date', label:'Release date'}]


    

    const changeGroupByOption = (data) =>{
        setGroupBy(data)
      }

    const changeArtistOption = (data) =>{
       setArtistFilter(data)
      }

    const changeLabelOption = (data) =>{
        setLabelFilter(data)
      }

      const changeStatusOption = (data) =>{
        setStatusFilter(data)
      }

      const changeTagOption = (data) =>{
        setTagFilter(data)
      }

      const changDsptOption = (data) =>{
        setDSPFilter(data)
      }

      const changeSortOption = (data) =>{
        setSortByFilter(data)
      }

     function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

      const colourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '8.75em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'0.5em',
        marginRight:'0.5em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
        hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          }),
          menuList: (base) => ({
            ...base,
        
            "::-webkit-scrollbar": {
              width: "0px",
              height: "0px",
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
              background: "#555"
            }
          })
      };

      const colourStylesBig = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '12.75em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'0.5em',
        marginRight:'0.5em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
        hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          }),
          menuList: (base) => ({
            ...base,
        
            "::-webkit-scrollbar": {
              width: "0px",
              height: "0px",
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
              background: "#555"
            }
          })
      };
    
    useEffect(()=>{
        topFunction()
        nav("Catalog")
    },[])
    
    return (
        <div>
              <div style={{
               display:'flex',
               flexDirection:'row',
               backgroundColor:'rgba(0,0,0,16%)',
               alignItems:'center',
               width:'22.625em',
               marginBottom:'1.5em',
               height:'2.5em',
               borderRadius:'4px',
               border:'1px solid rgba(255,255,255,20%)'
           }}>
               <img src={WhiteSearchIcon} style={{width:'1.25em',height:'1.25em', marginLeft:'0.75em',marginRight:'0.5em'}}/>
               <input 
               value={search}
               onChange={e=>setSearch(e.target.value)}
               type="text"
               className="catalogSearchInput"
               placeholder="Search"
               />
           </div>


            

            <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',justifyContent:'flex-start',marginTop:'1.5em',width:'100%',position:'relative'}}>
                <div className="ViewTxt">
                   Filter by:
                </div>

                <Select options={artistOptions} value={artistFilter} onChange={changeArtistOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Artists"
                    styles={
                      colourStyles
                    }
                    />

                <Select options={labelOptions} value={labelFilter} onChange={changeLabelOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Labels"
                    styles={
                      colourStyles
                    }
                    />

                <Select options={statusOptions} value={statusFilter} onChange={changeStatusOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Status"
                    styles={
                        colourStylesBig
                    }
                    />

                 <Select options={tagsOptions} value={tagFilter} onChange={changeTagOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Tags"
                    styles={
                      colourStyles
                    }
                    />

                <Select options={dspOptions} value={dspFilter} onChange={changDsptOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="DSP"
                    styles={
                      colourStyles
                    }
                    />

                <Select options={sortByOptions} value={sortByFilter} onChange={changeSortOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Sort by: Date Added"
                    styles={
                        colourStylesBig
                    }
                    />
                
           </div>

           <div style={{display:'flex',flexDirection:'column',borderRadius:'8px',overflow:'hidden',marginTop:'1.5em'}}>
                <div style={{display:'flex',flexDirection:'row',backgroundColor:'rgba(255,255,255,8%)'}}>
                    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em',marginLeft:'1em',paddingTop:'0.68em',paddingBottom:'0.68em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                            DSP
                        </div>
                        <img src={royaltiesfluctuateicon} style={{marginLeft:'0.5em'}}/>
                    </div>
                   

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em',paddingTop:'0.68em',paddingBottom:'0.68em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                            Streams
                        </div>
                        <img src={royaltiesfluctuateicon} style={{marginLeft:'0.5em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em',paddingTop:'0.68em',paddingBottom:'0.68em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                            Downloads
                        </div>
                        <img src={royaltiesfluctuateicon} style={{marginLeft:'0.5em'}}/>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',paddingRight:'2.5em',backgroundColor:'rgba(255,255,255,16%)'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em',fontWeight:'600'}}>
                           Revenue
                        </div>
                        <img src={royaltiesdownicon} style={{marginLeft:'0.5em'}}/>
                    </div>
                </div>
                {/* {DSP:"Amazon Prime",Streams:"442,853",Downloads:"0",Revenue:"$654.51"}] */}
                {
                  dummydata.map((data)=>{
                    return (
                      <div style={{display:'flex',flexDirection:'row',paddingTop:'0.68em',paddingBottom:'0.68em',backgroundColor:'rgba(255,255,255,2%)'}}>
                    
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em',marginLeft:'1em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                            {data.DSP}
                        </div>
                      </div>
                   

                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                          {data.Streams}
                        </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                          {data.Downloads}
                        </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'21.58%',marginRight:'2.5em'}}>
                        <div className="ColumnHeader" style={{marginLeft:'1em'}}>
                        {data.Revenue}
                        </div>
                    </div>
                </div>
                    )
                  })
                }

              
           </div>
        </div>
       
    );
}

export default Artists;